type ResolveSliderInitialIndexOptions = {
  galleryLength: number,
  initialIndex: number,
  imageHash?: string,
  imageQuery?: string,
  resolveUrl: boolean
}

type ParagraphWithType = { paragraphType?: string }

export const getSliderImageQuery = (url: string): string | undefined => {
  const queryStart = url.indexOf('?')
  if (queryStart === -1) return

  return new URLSearchParams(url.slice(queryStart + 1)).get('image') ?? undefined
}

export const isUrlResponsibleSlider = (paragraphs: ParagraphWithType[], index: number, includeDepth: number): boolean =>
  includeDepth === 0 && paragraphs.findIndex(paragraph => paragraph.paragraphType === 'slider') === index

export const isSliderIndexInActiveWindow = (index: number, currentIndex: number, galleryLength: number): boolean => {
  if (galleryLength <= 0) return false
  if (galleryLength <= 3) return true

  const previousIndex = (currentIndex - 1 + galleryLength) % galleryLength
  const nextIndex = (currentIndex + 1) % galleryLength
  return index === previousIndex || index === currentIndex || index === nextIndex
}

const normalizeSliderIndex = (value: number, galleryLength: number): number | undefined =>
  Number.isInteger(value) && value >= 0 && value < galleryLength ? value : undefined

export const resolveSliderInitialIndex = ({
  galleryLength,
  initialIndex,
  imageHash,
  imageQuery,
  resolveUrl
}: ResolveSliderInitialIndexOptions): number => {
  const fallbackIndex = normalizeSliderIndex(initialIndex, galleryLength) ?? 0
  if (!resolveUrl) return fallbackIndex

  if (imageHash?.startsWith('#image=')) {
    const hashIndex = normalizeSliderIndex(Number(imageHash.replace('#image=', '')) - 1, galleryLength)
    if (hashIndex !== undefined) return hashIndex
  }

  return normalizeSliderIndex(Number(imageQuery) - 1, galleryLength) ?? fallbackIndex
}
